import childrenDetails from './childrenDetails';
import addressDetails from './addressDetails';
import obfuscation from './obfuscation';
import onChange from './onChange';
import historyVisibilityBasedOnPersonalData from './historyVisibilityBasedOnPersonalData';
import onOwnerPurchaseYearChange from './onOwnerPurchaseYearChange';
import showMorePersonalData from './showMorePersonalData';
import nameAndLastnameChange from './nameAndLastnameChange';
import onOwnerLastNameChange from './onOwnerLastNameChange';
import onOwnerNameChange from './onOwnerNameChange';
import onOwnerFamilyNameChange from './onOwnerFamilyNameChange';

export const owner = {
  ...childrenDetails,
  ...addressDetails,
  ...obfuscation,
  ...onChange,
  ...historyVisibilityBasedOnPersonalData,
  ...onOwnerPurchaseYearChange,
  ...showMorePersonalData,
  ...nameAndLastnameChange,
  ...onOwnerLastNameChange,
  ...onOwnerNameChange,
  ...onOwnerFamilyNameChange,
};
